import { Id } from "@dhx/ts-common/types";
import { DataStore } from "@xbs/muon";
import { IAction, IActionConfig, SpreadsheetEvents } from "../types";

export class AddSheet implements IAction {
	public config: IActionConfig;
	private _id: Id;
	private _store: DataStore;

	constructor(config: IActionConfig) {
		this.config = config;
		this._store = config.dataStore;
	}

	do() {
		const { sheets, val } = this.config;
		if (sheets.find(i => i.value === val)) return;
		this._store.addPage(val);
		const cols = [];
		const rows = [];
		for (let i = 0; i < this.config.spreadsheet.config.colsCount; i++) {
			cols.push({ width: 120 });
		}
		for (let i = 0; i < this.config.spreadsheet.config.rowsCount; i++) {
			rows.push({ height: (this.config.spreadsheet as any)._grid.config.rowHeight });
		}
		this._store.getPage(val).setMeta({ focusedCell: { cell: "A1" }, selectedCells: ["A1"], cols, rows });
		const currentSheetId = this.config.spreadsheet.getActiveSheet().id;
		const currentSheetIndex = sheets.getIndex(currentSheetId);
		this._id = sheets.add({ value: val, id: this._id || null }, currentSheetIndex + 1);
		this.config.spreadsheet.events.fire(SpreadsheetEvents.afterSheetAdd, [{ name: val, id: this._id }]);
		(this.config.spreadsheet as any)._changeSheet(this._id);
		this.config.grid.paint();
	}

	undo() {
		this._store.removePage(this.config.val);
		this.config.sheets.remove(this._id);
		(this.config.spreadsheet as any)._changeSheet(this.config.prev);
	}
}
